// src/Montaan/Breadcrumb/index.tsx

export { default } from './Breadcrumb';
